// A small note in place (Figma "Inline note": Info / Warning / Error): what
// didn't work, with Try again if there is one.
import * as React from 'react';
import { cn } from '../../lib/utils';

const TONE = {
  info: ['border-border-default', 'bg-accent-default'],
  warning: ['border-zone-threshold', 'bg-zone-threshold'],
  error: ['border-status-danger', 'bg-status-danger'],
};

export function InlineNote({ text, tone = 'info', action, className }) {
  const [frame, dot] = TONE[tone];
  return (
    <div role={tone === 'error' ? 'alert' : 'status'}
      className={cn('flex items-start gap-2.5 rounded-chip border bg-bg-surface px-3.5 py-3', frame, className)}>
      <span aria-hidden="true" className={cn('mt-[6px] h-2 w-2 shrink-0 rounded-full', dot)} />
      <p className="m-0 flex-1 type-body-small text-text-body">{text}</p>
      {action ? (
        <button type="button" onClick={action.onClick} className="shrink-0 type-label text-accent-default hover:text-accent-hover">
          {action.label}
        </button>
      ) : null}
    </div>
  );
}
